import * as React from 'react'

import Meta from '~/components/meta'
import { createCustomerComplaintCodeMutation } from '~/gql/mutations'
import CustomerComplaintsScreen from '~/screens/customer-complaints'
import { flags } from '~/utils/constants'
import getMetaInfo, { GetMetaInfoResult } from '~/utils/get-meta-info'
import redirectTo from '~/utils/redirect-to'

interface CustomerComplaintsPageProps {
  metaInfo: GetMetaInfoResult
  code: string
}

const CustomerComplaintsPage = (props: CustomerComplaintsPageProps) => {
  const { metaInfo, code } = props

  return (
    <>
      <Meta {...metaInfo} title="Libro de reclamaciones" />
      <CustomerComplaintsScreen code={code} />
    </>
  )
}

CustomerComplaintsPage.standalone = true

CustomerComplaintsPage.getInitialProps = async (context: PageContext): Promise<CustomerComplaintsPageProps | void> => {
  if (!context.hasFlag(flags.CUSTOMER_COMPLAINTS)) {
    return redirectTo('/', context)
  }

  const { data } = await context.apolloClient.mutate({
    mutation: createCustomerComplaintCodeMutation,
  })

  const { code } = data.createCustomerComplaintCode

  return { metaInfo: getMetaInfo(context), code }
}

export default CustomerComplaintsPage
